<div>
  <span
    class="material-icons close-btn"
    (click)="dialogRef.close(data?.isConditional ? null : false)"
  >
    close
  </span>
  <h2 mat-dialog-title class="text-center">{{ data?.title || "Confirm" }}</h2>
  <mat-divider class="yellow-divider"></mat-divider>
  <mat-dialog-content class="text-center">
    <p [innerHTML]="data?.displayMessage || 'Are you sure?'"></p>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button
      mat-flat-button
      mat-dialog-close
      (click)="dialogRef.close(false)"
      style="margin-right: 10px"
    >
      {{ data?.cancelBtn ? data.cancelBtn : "No" }}
    </button>
    <button mat-flat-button mat-dialog-close (click)="dialogRef.close(true)">
      {{ data?.confirmBtn ? data.confirmBtn : "Yes" }}
    </button>
  </mat-dialog-actions>
</div>
